<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="rows"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>
    <notification-dropdown-report @rows="setRows" />
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown } from "bootstrap-vue"
import NotificationDropdownReport from "./NotificationDropdownReport.vue"

export default {
  components: {
    BNavItemDropdown,
    NotificationDropdownReport,
  },
  data() {
    return {
      rows: 0,
    }
  },
  methods: {
    setRows(rows) {
      this.rows = rows
    },
  },
}
</script>
